var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VuePhoneNumberInput',{ref:"phoneInput",staticClass:"phone-number-input",attrs:{"default-country-code":_vm.selectedCountry,"translations":{
        phoneNumberLabel: _vm.$t('Broj telefona'),
        example: _vm.$t('Primjer'),
    },"size":"sm","data-test":"client-phone-number","border-radius":2},on:{"input":_vm.handlePhoneChange},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})
}
var staticRenderFns = []

export { render, staticRenderFns }